"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _globals = require("@insided/shared/utils/globals");

var _userAvatar = _interopRequireDefault(require("../../utils/userAvatar"));

var _index = _interopRequireDefault(require("../profile-popup/index"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _ReputationBar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/ReputationBar"));

var _AvatarLink = _interopRequireDefault(require("./AvatarLink"));

var _userAvatar2 = require("@insided/shared/utils/userAvatar");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'user-avatar';
exports.cssAnchorName = cssAnchorName;

// avatarImageUrl is in the format "{CDN_URL}/{COMMUNITY_NAME}/icon/{IMAGE_SIZE}/{IMAGE_ID}.png" or
// "{CDN_URL}/{COMMUNITY_NAME}/icon/{defaultSize}x{defaultSize}/{IMAGE_SIZE}/{IMAGE_ID}.png"
function transformAvatarImageUrlSize(avatarImageUrl, newSize) {
  var avatarImageUrlChunks = avatarImageUrl.split('/');
  var avatarName = avatarImageUrlChunks[avatarImageUrlChunks.length - 1];
  var baseUrl = avatarImageUrl.split('/icon/')[0];
  return "".concat(baseUrl, "/icon/").concat(newSize, "/").concat(avatarName);
}

var DEFAULT_AVATAR_URL_HOSTNAMES = ['uploads-eu-west-1.almostinsided.com', 'uploads-us-west-2.insided.com', 'uploads-eu-west-1.insided.com']; // TODO: Replace this funcitonality once the backend call has been chaned to return the URLs for different sizes by default

function getOptimizedAvatarImageElement(avatarImageUrl, userName) {
  var avatarUrl = new URL(avatarImageUrl);

  if (!DEFAULT_AVATAR_URL_HOSTNAMES.includes(avatarUrl.hostname)) {
    return (0, _preact.h)(_LazyImage.default, {
      type: "img",
      src: (0, _absoluteUrlRuntime.resolveUrl)(avatarImageUrl),
      style: {
        width: '100%'
      },
      alt: userName
    });
  }

  var avatarImageUrlStandardSize = transformAvatarImageUrlSize(avatarImageUrl, '40x40');
  var avatarImageUrlRetina2X = transformAvatarImageUrlSize(avatarImageUrl, '80x80');
  var avatarImageUrlRetina3X = transformAvatarImageUrlSize(avatarImageUrl, '120x120');
  var avatarImageSrcSet = "".concat(avatarImageUrlRetina2X, " 2x, ").concat(avatarImageUrlRetina3X, " 3x");
  return (0, _preact.h)(_LazyImage.default, {
    type: "img",
    src: (0, _absoluteUrlRuntime.resolveUrl)(avatarImageUrlStandardSize),
    srcSet: avatarImageSrcSet,
    style: {
      width: '100%'
    },
    alt: userName
  });
}

function getAvatarImageElement(user, isDefaultAvatar, optimizeAvatarResolution) {
  var _user$avatar;

  if (isDefaultAvatar) return (0, _preact.h)("div", {
    className: (0, _classnames.default)('default-avatar', _userAvatar.default.getAvatarClass(user.id))
  }, (0, _userAvatar2.getAvatarInitial)(user.name));
  var avatarImageUrl = (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : '';
  if (optimizeAvatarResolution && avatarImageUrl) return getOptimizedAvatarImageElement(avatarImageUrl, user.name);
  return (0, _preact.h)(_LazyImage.default, {
    type: "img",
    src: (0, _absoluteUrlRuntime.resolveUrl)(avatarImageUrl),
    style: {
      width: '100%'
    },
    alt: user.name
  });
}

var UserAvatar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserAvatar, _Component);

  var _super = _createSuper(UserAvatar);

  function UserAvatar() {
    var _this;

    (0, _classCallCheck2.default)(this, UserAvatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      ref: false,
      disablePopup: typeof window !== 'undefined' && (0, _insidedDataStorage.getInsidedData)('device') !== 'desktop' || !!_this.props.disablePopup,
      disableLink: !!_this.props.disableLink
    });
    return _this;
  }

  (0, _createClass2.default)(UserAvatar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        ref: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          user = _this$props.user,
          extraClass = _this$props.extraClass,
          showRank = _this$props.showRank,
          style = _this$props.style,
          openInNewTab = _this$props.openInNewTab,
          optimizeAvatarResolution = _this$props.optimizeAvatarResolution,
          reputationLevel = _this$props.reputationLevel,
          disableReputation = _this$props.disableReputation;
      var id = user.id,
          name = user.name,
          rank = user.rank,
          avatar = user.avatar;
      var _this$state = this.state,
          disablePopup = _this$state.disablePopup,
          disableLink = _this$state.disableLink;

      if (id) {
        var _this$ref;

        var isDefaultAvatar = _userAvatar.default.isDefaultAvatar(avatar);

        var avatarImageElement = getAvatarImageElement(user, isDefaultAvatar, optimizeAvatarResolution !== null && optimizeAvatarResolution !== void 0 ? optimizeAvatarResolution : false);
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('avatar', extraClass),
          style: _objectSpread({
            float: 'none'
          }, style)
        }, (0, _preact.h)("div", {
          className: "profilepicture qa-profile-picture",
          ref: function ref(r) {
            _this2.ref = r;
          }
        }, (0, _preact.h)(_AvatarLink.default, {
          user: user,
          disableLink: disableLink,
          openInNewTab: openInNewTab,
          className: "default-avatar-link qa-topic-meta-last-user-icon"
        }, avatarImageElement, showRank && rank !== null && rank !== void 0 && rank.avatarIconUrl ? (0, _preact.h)("div", {
          className: "profilelabel qa-profile-label"
        }, (0, _preact.h)("img", {
          src: (0, _absoluteUrlRuntime.resolveUrl)(rank.avatarIconUrl),
          alt: rank.name,
          title: rank.name
        })) : null), this.state.ref && !disablePopup && (0, _preact.h)(_index.default, {
          hoverControl: (_this$ref = this.ref) !== null && _this$ref !== void 0 ? _this$ref : undefined,
          memberId: typeof id === 'number' ? id : parseInt(id),
          reputationLevel: reputationLevel
        })), (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
          var showReputation = modules.includes('reputation') && !disableReputation && reputationLevel !== undefined;
          return showReputation ? (0, _preact.h)(_ReputationBar.default, {
            reputationLevel: reputationLevel
          }) : null;
        }));
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('avatar', extraClass),
        style: _objectSpread({
          float: 'none'
        }, style)
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('profilepicture', 'qa-profile-picture', 'default-avatar-link', 'qa-topic-meta-last-user-icon', 'default-cursor')
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('default-avatar', _userAvatar.default.getAvatarClass(id))
      }, (0, _userAvatar2.getAvatarInitial)(name))));
    }
  }]);
  return UserAvatar;
}(_preact.Component);

var _default = UserAvatar;
exports.default = _default;